import React, { Component } from 'react';
import './App.css';
// import Dummy from './Dummy.json';

class App extends Component {

  state = {
    items: [],
  };

  shuffle = (array) => {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  componentDidMount = () => {
    fetch('http://eightfivezero.com/insta.json')
      .then(function(response) {
        return response.json()
      }).then((json) => {
        const finalItems = this.shuffle(json.items);
        this.setState({
          items: finalItems,
        });
      }).catch((ex) => {
        console.log(ex);
      });
    // 2203744.2f1de76.e6c762a46f9845218150d1093c9e8688

    // const DummyItems = this.shuffle(Dummy.items);
    //
    // this.setState({
    //   items: DummyItems,
    // });
  }

  render() {
    return (
      <div className="App">
        <div className="App-header">
          {/* <img src={logo} className="App-logo" alt="logo" /> */}
          <h1>@eightfivezero</h1>
        </div>
        <div className="App-content">
          {this.state.items.map(item =>
            <a
              className="photo"
              key={`Result-${item.id}`}
              href={item.link}
              style={{backgroundImage: `url(${item.images.standard_resolution.url})`}}
            >
            </a>
          )}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js